import {css} from '@logistics-frontend/blocks/theme/css'

export const classes = {
  input: css`
    display: none;
  `,
}
